<template>
    <v-snackbar v-model="snackbar" :color="snackbarColor" :top="top" :bottom="bottom" :left="left" :right="right" :timeout="timeout">
        {{ errorMessage }}

        <template #action="{ attrs }">
            <v-btn color="white" icon v-bind="attrs" @click="snackbar = false">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </template>
    </v-snackbar>
</template>

<script>
export default {
    data() {
        return {
            snackbar: false,
            errorMessage: '',
            snackbarColor: '',
            timeout: 5000,
        }
    },
    props: {
        top: {
            type: Boolean,
            required: false,
            default: true
        },
        bottom: {
            type: Boolean,
            required: false,
            default: false
        },
        left: {
            type: Boolean,
            required: false,
            default: false
        },
        right: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    created() {
        this.$store.subscribe((mutation, state) => {
            if (mutation.type === 'snackbar/showMessage') {
                this.errorMessage = state.snackbar.content
                this.snackbarColor = state.snackbar.color
                this.snackbar = true
            }
        })
    },
}
</script>
